export function makeSqlUrl(
    query: string,
    title: string,
    pageSize: number,
    parameterArguments: Record<string, string>
): URL {
    const url = new URL(`${window.location.origin}/Sql/Result`);
    url.searchParams.set('query', query);
    if (title) {
        url.searchParams.set('title', title);
    }
    if (pageSize) {
        url.searchParams.set('pageSize', pageSize.toString());
    }
    for (const parameterName in parameterArguments) {
        url.searchParams.set(parameterName, parameterArguments[parameterName]);
    }
    return url;
}

export function makeSavedSqlUrl(
    guid: string,
    name: string,
    parameterArguments: Record<string, string>,
    optionalTitle?: string
): URL {
    const url = new URL(`${window.location.origin}/Sql/Result/Saved/${encodeURIComponent(guid)}`);
    if (optionalTitle) {
        url.searchParams.set('title', optionalTitle);
    } else if (name) {
        const nameEncoded = name.split('/').map(encodeURIComponent).join('/');
        url.hash = `#${nameEncoded}`;
    }
    for (const parameterName in parameterArguments) {
        url.searchParams.set(parameterName, parameterArguments[parameterName]);
    }
    return url;
}
